export default __webpack_public_path__ + "static/media/Escola.8aaaa3b9.png";